import posthog from "posthog-js";

export const IDENTIFY_USER = (user_id,properties)=>{
    posthog.identify(user_id,properties)
}
export const CAPTURE_EVENT =(event_name,properties)=>{
    console.log(`${event_name} is triggered`)
    posthog.capture(event_name,properties)
}